<template>
    <v-expansion-panel-content class="bg-gray">
        <template v-slot:header>
            <v-card-title class="justify-space-between py-0 px-0">
                <div>
                    <v-btn @click="moveUpQuestion(index)" :disabled="index === 0" icon class="m-0">
                        <v-icon>mdi-arrow-up</v-icon>
                    </v-btn>
                    <v-btn @click="moveDownQuestion(index)" :disabled="index === formGroup.questions.length - 1" icon class="m-0">
                        <v-icon>mdi-arrow-down</v-icon>
                    </v-btn>
                    <span>{{ index + 1 }}. Question: {{ text }}</span>
                </div>
            </v-card-title>
        </template>
        <v-card class="mt-3 mb-3 bg-gray">
            <v-card-text>
                <v-layout row class="align-items-center">
                    <v-text-field
                        v-model="text"
                        label="Question"
                        :rules="[v => !!v || 'Question est requise']"
                    ></v-text-field>
                    <SurveyClipboardButton :text-original="textOriginal"/>
                </v-layout>
                <v-select
                    v-model="special_type"
                    label="Type"
                    :items="getSpecialTypeLabels"
                ></v-select>
                <v-expansion-panel v-model="answersPanel" expand :id="'answers-' + index">
                    <survey-answer-form
                        v-for="(answer, answerIndex) in answers"
                        :key="answer.id"
                        :index="answerIndex"
                        :answer="answer"
                        :questionIndex="index">
                    </survey-answer-form>
                </v-expansion-panel>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" v-if="question.can.delete" @click="removeQuestion(index)">Supprimer</v-btn>
                <v-btn color="primary" @click="handleNewAnswer">Ajouter une réponse</v-btn>
            </v-card-actions>
        </v-card>
    </v-expansion-panel-content>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import SurveyAnswerForm from "./SurveyAnswerForm.vue";
import i18n from "../../i18n";
import SurveyClipboardButton from "./components/SurveyClipboardButton.vue";

export default {
    name: "SurveyQuestionForm",
    components: {SurveyClipboardButton, SurveyAnswerForm},
    data: () => ({
        answersPanel: [],
    }),
    props: {
        question: {
            type: Object,
        },
        index: {
            type: Number,
        }
    },
    computed: {
        ...mapGetters('surveys', {
            getSpecialTypeLabels: 'getSpecialTypeLabels',
        }),
        ...mapState('surveys', {
            formGroup: 'form_group',
        }),
        text: {
            get() {
                return this.$store.state.surveys.form_group.questions[this.index].text
            },
            set(text) {
                this.setText({index: this.index, text})
            },
        },
        textOriginal() {
            return this.$store.state.surveys.form_group.questions[this.index].textOriginal
        },
        special_type: {
            get() {
                return this.$store.state.surveys.form_group.questions[this.index].special_type
            },
            set(special_type) {
                this.setSpecialType({index: this.index, special_type})
            },
        },
        answers: {
            get() {
                return this.$store.state.surveys.form_group.questions[this.index].answers
            },
        },
    },
    methods:{
        handleNewAnswer() {
            this.addNewAnswer(this.index)
            this.answersPanel = this.answers.map(() => false)
            this.answersPanel[this.answersPanel.length - 1] = true
        },
        ...mapMutations('surveys', {
            setText: 'setFormQuestionText',
            setSpecialType: 'setFormQuestionSpecialType',
            removeQuestion: 'removeQuestion',
            moveUpQuestion: 'moveUpQuestion',
            moveDownQuestion: 'moveDownQuestion',
        }),
        ...mapActions('surveys', [
            'addNewAnswer',
            'removeAnswer',
        ]),
        ...mapActions('notifications', {
            showSuccess: 'showSuccess',
        }),
    }
}
</script>

<style scoped>
.bg-gray {
    background-color: #f0f0f0 !important;
}
</style>

